module.exports = __webpack_public_path__ + "static/media/ai-math-popup-title.54d42538.png";